/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdminResetPasswordResp,
  ChangePasswordReq,
  CreateUserReq,
  CreateUserResp,
  DisableUserReq,
  ListUserOptionsParams,
  ListUsersParams,
  UpdateUserReq,
  UserListItem,
  UserOptionResp,
} from "./user-api.schemas.js";
import type { MeResp } from "./common.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const Me = (
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<MeResp>(
    { url: `/intl/user/me`, method: "GET", signal },
    options,
  );
};

export const getMeQueryKey = () => {
  return [`/intl/user/me`] as const;
};

export const getMeQueryOptions = <
  TData = Awaited<ReturnType<typeof Me>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof Me>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiRequest>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof Me>>> = ({ signal }) =>
    Me(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof Me>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof Me>>>;
export type MeQueryError = unknown;

export function useMe<TData = Awaited<ReturnType<typeof Me>>, TError = unknown>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Me>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof Me>>,
          TError,
          Awaited<ReturnType<typeof Me>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMe<TData = Awaited<ReturnType<typeof Me>>, TError = unknown>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Me>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof Me>>,
          TError,
          Awaited<ReturnType<typeof Me>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useMe<TData = Awaited<ReturnType<typeof Me>>, TError = unknown>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Me>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useMe<TData = Awaited<ReturnType<typeof Me>>, TError = unknown>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof Me>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const UpdateMe = (
  updateUserReq?: UpdateUserReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<MeResp>(
    {
      url: `/intl/user/me`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateUserReq,
      signal,
    },
    options,
  );
};

export const getUpdateMeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof UpdateMe>>,
    TError,
    { data?: UpdateUserReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof UpdateMe>>,
  TError,
  { data?: UpdateUserReq },
  TContext
> => {
  const mutationKey = ["updateMe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof UpdateMe>>,
    { data?: UpdateUserReq }
  > = (props) => {
    const { data } = props ?? {};

    return UpdateMe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMeMutationResult = NonNullable<
  Awaited<ReturnType<typeof UpdateMe>>
>;
export type UpdateMeMutationBody = UpdateUserReq | undefined;
export type UpdateMeMutationError = unknown;

export const useUpdateMe = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof UpdateMe>>,
      TError,
      { data?: UpdateUserReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof UpdateMe>>,
  TError,
  { data?: UpdateUserReq },
  TContext
> => {
  return useMutation(getUpdateMeMutationOptions(options), queryClient);
};
export const ChangePassword = (
  changePasswordReq?: ChangePasswordReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/user/password`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: changePasswordReq,
      signal,
    },
    options,
  );
};

export const getChangePasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ChangePassword>>,
    TError,
    { data?: ChangePasswordReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ChangePassword>>,
  TError,
  { data?: ChangePasswordReq },
  TContext
> => {
  const mutationKey = ["changePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ChangePassword>>,
    { data?: ChangePasswordReq }
  > = (props) => {
    const { data } = props ?? {};

    return ChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof ChangePassword>>
>;
export type ChangePasswordMutationBody = ChangePasswordReq | undefined;
export type ChangePasswordMutationError = unknown;

export const useChangePassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ChangePassword>>,
      TError,
      { data?: ChangePasswordReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ChangePassword>>,
  TError,
  { data?: ChangePasswordReq },
  TContext
> => {
  return useMutation(getChangePasswordMutationOptions(options), queryClient);
};
export const ListUserOptions = (
  params?: ListUserOptionsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UserOptionResp[]>(
    { url: `/intl/user/options`, method: "GET", params, signal },
    options,
  );
};

export const getListUserOptionsQueryKey = (params?: ListUserOptionsParams) => {
  return [`/intl/user/options`, ...(params ? [params] : [])] as const;
};

export const getListUserOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof ListUserOptions>>,
  TError = unknown,
>(
  params?: ListUserOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListUserOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUserOptionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ListUserOptions>>> = ({
    signal,
  }) => ListUserOptions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ListUserOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUserOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof ListUserOptions>>
>;
export type ListUserOptionsQueryError = unknown;

export function useListUserOptions<
  TData = Awaited<ReturnType<typeof ListUserOptions>>,
  TError = unknown,
>(
  params: undefined | ListUserOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListUserOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListUserOptions>>,
          TError,
          Awaited<ReturnType<typeof ListUserOptions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserOptions<
  TData = Awaited<ReturnType<typeof ListUserOptions>>,
  TError = unknown,
>(
  params?: ListUserOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListUserOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListUserOptions>>,
          TError,
          Awaited<ReturnType<typeof ListUserOptions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUserOptions<
  TData = Awaited<ReturnType<typeof ListUserOptions>>,
  TError = unknown,
>(
  params?: ListUserOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListUserOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListUserOptions<
  TData = Awaited<ReturnType<typeof ListUserOptions>>,
  TError = unknown,
>(
  params?: ListUserOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListUserOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUserOptionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const CreateUser = (
  createUserReq?: CreateUserReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CreateUserResp>(
    {
      url: `/intl/user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createUserReq,
      signal,
    },
    options,
  );
};

export const getCreateUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof CreateUser>>,
    TError,
    { data?: CreateUserReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof CreateUser>>,
  TError,
  { data?: CreateUserReq },
  TContext
> => {
  const mutationKey = ["createUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof CreateUser>>,
    { data?: CreateUserReq }
  > = (props) => {
    const { data } = props ?? {};

    return CreateUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof CreateUser>>
>;
export type CreateUserMutationBody = CreateUserReq | undefined;
export type CreateUserMutationError = unknown;

export const useCreateUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof CreateUser>>,
      TError,
      { data?: CreateUserReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof CreateUser>>,
  TError,
  { data?: CreateUserReq },
  TContext
> => {
  return useMutation(getCreateUserMutationOptions(options), queryClient);
};
export const ListUsers = (
  params?: ListUsersParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UserListItem[]>(
    { url: `/intl/user/list`, method: "GET", params, signal },
    options,
  );
};

export const getListUsersQueryKey = (params?: ListUsersParams) => {
  return [`/intl/user/list`, ...(params ? [params] : [])] as const;
};

export const getListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof ListUsers>>,
  TError = unknown,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ListUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ListUsers>>> = ({
    signal,
  }) => ListUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ListUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof ListUsers>>
>;
export type ListUsersQueryError = unknown;

export function useListUsers<
  TData = Awaited<ReturnType<typeof ListUsers>>,
  TError = unknown,
>(
  params: undefined | ListUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ListUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListUsers>>,
          TError,
          Awaited<ReturnType<typeof ListUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsers<
  TData = Awaited<ReturnType<typeof ListUsers>>,
  TError = unknown,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ListUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListUsers>>,
          TError,
          Awaited<ReturnType<typeof ListUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsers<
  TData = Awaited<ReturnType<typeof ListUsers>>,
  TError = unknown,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ListUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListUsers<
  TData = Awaited<ReturnType<typeof ListUsers>>,
  TError = unknown,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ListUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const DisableUser = (
  id: string,
  disableUserReq?: DisableUserReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/user/${id}/disable`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: disableUserReq,
      signal,
    },
    options,
  );
};

export const getDisableUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof DisableUser>>,
    TError,
    { id: string; data?: DisableUserReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof DisableUser>>,
  TError,
  { id: string; data?: DisableUserReq },
  TContext
> => {
  const mutationKey = ["disableUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof DisableUser>>,
    { id: string; data?: DisableUserReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return DisableUser(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisableUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof DisableUser>>
>;
export type DisableUserMutationBody = DisableUserReq | undefined;
export type DisableUserMutationError = unknown;

export const useDisableUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof DisableUser>>,
      TError,
      { id: string; data?: DisableUserReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof DisableUser>>,
  TError,
  { id: string; data?: DisableUserReq },
  TContext
> => {
  return useMutation(getDisableUserMutationOptions(options), queryClient);
};
export const EnableUser = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/intl/user/${id}/enable`, method: "PUT", signal },
    options,
  );
};

export const getEnableUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof EnableUser>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof EnableUser>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["enableUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof EnableUser>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return EnableUser(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EnableUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof EnableUser>>
>;

export type EnableUserMutationError = unknown;

export const useEnableUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof EnableUser>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof EnableUser>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getEnableUserMutationOptions(options), queryClient);
};
export const AdminResetPassword = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<AdminResetPasswordResp>(
    { url: `/intl/user/${id}/reset-password`, method: "PUT", signal },
    options,
  );
};

export const getAdminResetPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof AdminResetPassword>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof AdminResetPassword>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminResetPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof AdminResetPassword>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return AdminResetPassword(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof AdminResetPassword>>
>;

export type AdminResetPasswordMutationError = unknown;

export const useAdminResetPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof AdminResetPassword>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof AdminResetPassword>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getAdminResetPasswordMutationOptions(options),
    queryClient,
  );
};
